<template>
  <div class="mini-banner-animation">
    <DefSlideRight :appear="true">
      <div v-if="isShow && item" :key="item.id" class="footer-mini-banner">
        <button class="footer-mini-banner__close" @click="closeBanner">
          <svg>
            <use xlink:href="#svg-close"></use>
          </svg>
        </button>
        <a
          :href="getHref(item)"
          class="footer-mini-banner__link"
          @click.prevent="openSubscribeModal($event)"
        >
          <div v-if="item.html">
            <DefInsertTildaSlider :result="item.html" />
          </div>
          <DefVideo v-else-if="item.video" :result="item.video" loop />
          <DefImg v-else :result="item.animation || item.picture" />
        </a>
      </div>
    </DefSlideRight>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import DefSlideRight from '@components/Def/DefAnimations/DefSlideRight.vue';
import DefInsertTildaSlider from '@components/Def/DefInsertTilda/DefInsertTildaSlider.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import useModal from '@use/useModal/useModal';
import ShoppingPresent from '@components/Modals/ShoppingPresent.vue';

export default {
  name: 'FooterMiniBanner',
  components: { DefImg, DefVideo, DefInsertTildaSlider, DefSlideRight },
  props: ['result'],
  data() {
    return {
      item: {},
      interval: '',
      showNextItemDate: '',
      modal: useModal(),
    };
  },
  computed: {
    ...mapGetters({
      getItem: 'footerMiniBanner/getItem',
      isShow: 'footerMiniBanner/getIsShow',
    }),
  },
  methods: {
    ...mapActions({
      handlerRemove: 'footerMiniBanner/handlerRemove',
    }),
    ...mapMutations({
      setIsShow: 'footerMiniBanner/setIsShow',
    }),
    init() {
      const wasClosed = window.sessionStorage.getItem('wasClosedFooterMiniBanner');
      if (wasClosed) {
        this.setShowNextItemDate();
        this.interval = setInterval(() => {
          if (new Date(this.showNextItemDate) <= new Date()) {
            this.setNextItem();
          }
        }, 1000);
      } else {
        this.item = this.getItem;
      }
    },
    setNextItem() {
      this.item = this.getItem;
      this.setIsShow(true);
      window.sessionStorage.removeItem('wasClosedFooterMiniBanner');
      window.sessionStorage.removeItem('footerMiniBannerShowAfter');
      clearInterval(this.interval);
    },
    setShowNextItemDate() {
      let showNextItemDate = window.sessionStorage.getItem('footerMiniBannerShowAfter');
      if (!showNextItemDate) {
        showNextItemDate = new Date();
        showNextItemDate.setSeconds(
          showNextItemDate.getSeconds() + this.result.showNextItemTimeOut
        );
        window.sessionStorage.setItem('footerMiniBannerShowAfter', showNextItemDate);
      }
      this.showNextItemDate = showNextItemDate;
    },
    openSubscribeModal(event) {
      if (this.item.isOpenSubscribeModal) {
        this.modal.show(
          ShoppingPresent,
          {},
          {
            width: '1200px',
            empty: true,
          }
        );
      } else {
        location.href = event.currentTarget.getAttribute('href');
      }
    },
    /**
     * @see https://sova-jewels.atlassian.net/browse/SOVA-587
     * @todo REPLACE ALL javascript:void inserts in order to increase SEO optimizing
     * @param item
     * @returns {string|*}
     */
    getHref(item) {
      return this.item.isOpenSubscribeModal ? '#' : item.link || item.detailPage;
    },
    closeBanner() {
      this.handlerRemove();
      window.sessionStorage.setItem('wasClosedFooterMiniBanner', true);
      this.init();
    },
  },
  beforeMount() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.footer-mini-banner {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 30vw;
  max-width: 300px;
  min-width: 200px;
  z-index: 2;

  &__close {
    z-index: 1;
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
    background-color: transparent;

    svg {
      display: block;
      width: 24px;
      height: 24px;
      transition: 0.2s linear fill;
      border-radius: 50%;
      border: 3px solid var(--background-beige);
      background-color: var(--background-beige);
    }

    &:hover {
      svg {
        fill: var(--color-red);
      }
    }
  }
}
.mini-banner-animation {
  :deep(.def-slide-right-enter-active),
  :deep(.def-slide-right-leave-active) {
    transition: all 1s;
  }
  //.def-slide-right-enter-active,
  //.def-slide-right-leave-active {
  //    transition: all 5s;
  //}
}
</style>
